import { connect } from 'react-redux'
import { selectCurrentAgent } from 'selectors/agents/base'
import selectShowShopifyInstall from 'ducks/integrations/selectors/selectShowShopifyInstall'
import View from './view'

const select = state => ({
  currentAgent: selectCurrentAgent(state),
  showInstall: selectShowShopifyInstall(state),
})

export default connect(select, null)(View)
